import { MaterialReceiveItem, AddMaterialParam, AddMaterialReceiveItemResult, TmpGoodsReceiveImport, MaterialReceiveImport, MaterialReceiveCriteria, GenerateMatBarcode, GenerateMatBarcodeResult, AddReceiveItemModel, GetStockItem4Barcode } from './../model/material-receive.model';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpHeaders, HttpClient } from '../../../node_modules/@angular/common/http';
import { tap, catchError } from '../../../node_modules/rxjs/operators';
import { Observable } from '../../../node_modules/rxjs';
import { of } from '../../../node_modules/rxjs/observable/of';
import { User } from '../model/user.model';
import { UpdateGRExModel } from '../model/finish-goods.model';


const API_URL = environment.apiUrl;

const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};

@Injectable()
export class MaterialReceiveService {
  private Url = '';  // URL to web api
  currentUser: User;

  constructor(
    private http: HttpClient) {

    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/MaterialReceive';
    // console.log(this.currentUser);
  }

  GetMaterialReceiveList(search: MaterialReceiveCriteria): Observable<any> {
    return this.http.post<any>(this.Url + "/GetMaterialReceiveList", search, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

  GetMaterialReceiveForExport(search: MaterialReceiveCriteria, type: number): Observable<any> {

    return this.http.post(this.Url + '/GetMatReceiveForExport/' + type, search, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      }),
      responseType: 'arraybuffer'
    }).pipe(tap((x) => {
    }),
      catchError(this.handleError<MaterialReceiveCriteria>('GetMaterialReceiveForExport'))
    );
  }



  GetMaterialReceiveByID(id: number): Observable<MaterialReceiveItem> {
    return this.http.get<MaterialReceiveItem>(this.Url + "/" + id.toString(), httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

  ImportMaterialReceive(item: MaterialReceiveImport[]): Observable<any> {
    return this.http.post<MaterialReceiveImport[]>(this.Url + "/AddTmpGoodsReceiveImport", item, httpOptions).pipe(
      tap((res: any) => this.log(`added  w/ id=${res.id}`)),
      catchError(this.handleError<any>('Import CSV'))
    );
  }

  CheckGoodsReceiveImport(data: AddMaterialParam): Observable<TmpGoodsReceiveImport[]> {
    return this.http.post<TmpGoodsReceiveImport[]>(this.Url + "/CheckGoodsReceiveImport", data, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

  GenerateMaterialBarCode(data: GenerateMatBarcode): Observable<GenerateMatBarcodeResult[]> {
    return this.http.post<GenerateMatBarcodeResult[]>(this.Url + "/GenerateMatBarcode", data, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }


  GenerateMatBarcodePDF(data: GenerateMatBarcode): Observable<any> {
    return this.http.post<any>(this.Url + "/GenerateMatBarcodePDF", data, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

  GenerateMaterialBarcodeP2PDF(data: GenerateMatBarcode): Observable<any> {
    return this.http.post(this.Url + "/GenerateMaterialBarcodeP2PDF", data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType: 'arraybuffer',
      observe: 'response'
    }).pipe(
      tap(response => {
        // this.log(`fetched `)
      })
    );
  }

  GetStockItem4Barcode(data: GetStockItem4Barcode): Observable<GenerateMatBarcodeResult[]> {
    return this.http.post<GenerateMatBarcodeResult[]>(this.Url + "/GetStockItem4Barcode", data, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }


  UpdateGREx(data: Array<UpdateGRExModel>): Observable<any> {
    return this.http.post<any>(this.Url + "/UpdateGREx", data, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

  GetStockItem4BarcodePDF(data: GetStockItem4Barcode): Observable<any> {
    return this.http.post(this.Url + '/GetStockItem4BarcodePDF', data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType: 'arraybuffer'
    }).pipe(tap((x) => {
      // var file = new Blob([x], { type: 'application/pdf' });
      // var fileURL = URL.createObjectURL(file);
      // window.open(fileURL);
    }),
      // catchError(this.handleError<WorkpermitPDF>('workpermitPDF'))
    );
  }



  AddMaterialReceiveItem(data: AddMaterialParam): Observable<any> {
    return this.http.post<any>(this.Url + "/AddMaterialReceiveItem", data, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

  AddReceivedItem(data: AddReceiveItemModel): Observable<any> {

    return this.http.post<any>(this.Url + "/AddReceivedItem", data, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

  AddReceivedItemPDF(data: AddReceiveItemModel): Observable<any> {

    return this.http.post(this.Url + '/AddReceivedItemPDF', data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType: 'arraybuffer'
    }).pipe(tap((x) => {
      // var file = new Blob([x], { type: 'application/pdf' });
      // var fileURL = URL.createObjectURL(file);
      // window.open(fileURL);
    }),
      // catchError(this.handleError<WorkpermitPDF>('workpermitPDF'))
    );


  }

  DeleteTmpGoodsReceiveImport(data: AddMaterialParam): Observable<any> {
    return this.http.post<any>(this.Url + "/DeleteTmpGoodsReceiveImport", data, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }
  /**
    * Handle Http operation that failed.
    * Let the app continue.
    * @param operation - name of the operation that failed
    * @param result - optional value to return as the observable result
    */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a ScgCompanyService message with the MessageService */
  private log(message: string) {
    console.log(message);
    // this.messageService.add('ScgCompanyService: ' + message);
  }


}



// WEBPACK FOOTER //
// ./src/app/services/material-receive.service.ts